<div style="overflow:initial;height:100%">

    <div class="container">

        <form novalidate [formGroup]="formGroup">

            <div class="profileImageOuterDiv">
        
                <div class="avatar-upload">
                
                    <div class="avatar-edit">
                        
                        <input type='file' id="imageUpload" (change)="uploadProfilePic($event)"/>
        
                        <label for="imageUpload"><em class="fas fa-camera iconpic"></em></label>
      
                    </div>
      
                    <div class="avatar-preview">
        
                        <img id="imagePreview" class="imgclsss" src={{imgpre}} alt="img">
      
                    </div>
                
                </div>
  
            </div>

            <div class="row topRowMargins text-center">

                <div class="col-lg-12">

                    {{profileFields.userName}}

                </div>

            </div>

            <div class="row topRowMargins">

                <div class="col-lg-12">

                    <mat-form-field appearance="outline">

                        <mat-label i18n="@@rmcFirstName">First Name</mat-label>

                        <input matInput type="text" formControlName="firstName" [(ngModel)]="profileFields.firstName" readonly>

                    </mat-form-field>

                </div>

            </div>

            <div class="row topRowMargins">

                <div class="col-lg-12">

                    <mat-form-field appearance="outline">

                        <mat-label i18n="@@rmcLastName">Last Name</mat-label>

                        <input matInput type="text" formControlName="lastName" [(ngModel)]="profileFields.lastName" readonly>          

                    </mat-form-field>      

                </div>

            </div>

            <div class="row topRowMargins">

                <div class="col-lg-12">

                    <mat-form-field appearance="outline">

                        <mat-label i18n="@@rmcPhoneNumber">Phone Number</mat-label>

                        <input matInput type="text" formControlName="phoneNumber" [(ngModel)]="profileFields.phoneNumber" required>          

                        <mat-error *ngFor="let validation of validationMessages.phoneNumber">

                            <span *ngIf="formGroup.get('phoneNumber').hasError(validation.type) && (formGroup.get('phoneNumber').dirty || formGroup.get('phoneNumber').touched)">

                                {{validation.message}}

                            </span>

                        </mat-error>

                    </mat-form-field>

                </div>

            </div>

            <div class="row topRowMargins">

                <div class="col-lg-12">

                    <mat-form-field appearance="outline">

                        <mat-label i18n="@@rmcEmpNo">Emp No</mat-label>

                        <input matInput type="text" formControlName="empNo" [(ngModel)]="profileFields.empNo" readonly>          

                    </mat-form-field>      

                </div>

            </div>

        </form>

        <div class="row topRowMargins" style="margin-bottom:2%;font-weight:bolder">

            <div class="col-lg-12 text-center">

                Color Preference

            </div>

        </div>

        <div class="row topRowMargins text-center" *ngFor="let colorSchemeTemp of colorSchemeData">

            <div class="col-lg-2">

            </div>

            <div class="col-lg-2">

                {{colorSchemeTemp.schemename}}

            </div>

            <div class="col-lg-4">

                <div class="square" [style.background-color]="colorSchemeTemp.colora"></div>

                <div class="square" [style.background-color]="colorSchemeTemp.colorb"></div>

                <div class="square" [style.background-color]="colorSchemeTemp.colorc"></div>

                <div class="square" [style.background-color]="colorSchemeTemp.colord"></div>

            </div>

            <div class="col-lg-2">

                <input type="radio" [checked]='colorSchemeTemp.isColorSchemeIDBoolean' name="isColorSchemeIDBoolean" class="radioCss" (change)="changeColorSchemeID(colorSchemeTemp.colorschemeid)">

            </div>

            <div class="col-lg-2">

            </div>

        </div>

        <div class="row topRowMargins text-center">

            <div class="col-lg-12" style="margin-top:1%;margin-bottom:4%">

                <button i18n="@@TargetClear" type="button" (click)="updateUserRecord()" class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" style="background-color: #dd2c2cfa;padding-left:1.2rem;padding-right: 1.2rem;padding-top:0.4rem;padding-bottom:0.4rem" [style.background-color]="backgroundColorButton" >
                
                    Update
                
                </button>

            </div>

        </div>

    </div>

</div>